import React, { Component } from "react";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import DepartmentAchievers from "../component/DepartmentAchievers";
import DepartmentNumbers from "../component/DepartmentNumbers";
import Footer from "../../../components/common/Footer";
import DepartmentVideo from "../component/DepartmentVideo";

export default class CyberAbout extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />
        {/* Banner */}
        <Banner
          title="CSE (IOT & Cyber Security Including Blockchain Technology)"
          image="banners/department-cse.jpg"
        />
        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <DepartmentAchievers department="cyber" />
                  <DepartmentNumbers
                    text1="Number of students on roll"
                    num1="194"
                    text2="Number of Faculty"
                    num2="3"
                    text3="Number of Faculty with Ph.D"
                    num3="2"
                    text4="Number of Technical staff"
                    num4="2"
                    text5="Number of faculties pursuing Ph.D"
                    num5="1"
                    text6="Number of Publications"
                    num6="14"
                  />
                  <div className="ttm-service-description">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper">
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/departments/cyber/Picture1.png"
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-7 justify"
                        style={{ margin: "auto" }}
                      >
                        <p>
                          The Department of Computer Science and Engineering
                          (IoT & Cybersecurity including Blockchain Technology)
                          was established in the year 2022 with the vision to
                          produce industry-ready professionals equipped with the
                          knowledge and skills in emerging technologies. The
                          department focuses on interdisciplinary areas that are
                          shaping the future of secure, intelligent, and
                          connected systems.
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          With a curriculum tailored to meet the dynamic demands
                          of the industry, the department offers students
                          in-depth exposure to Internet of Things (IoT),
                          cybersecurity principles, and blockchain technologies.
                          Our dedicated faculty, modern laboratories, and
                          collaborative research environment support hands-on
                          learning and innovation.
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          The department emphasizes practical learning through
                          project-based education, industry internships, expert
                          lectures, and workshops. Students are encouraged to
                          participate in hackathons, research publications, and
                          startup initiatives, fostering a culture of creativity
                          and technical excellence
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          By integrating foundational computing knowledge with
                          cutting-edge technologies, the department aims to
                          nurture future leaders and problem-solvers for the
                          digital world.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Department Video</h4>
                    </div>
                    <iframe
                      title="1"
                      src="https://www.youtube.com/embed/NUGpk13640A"
                      frameBorder="0"
                      allow="autoplay; fullscreen"
                      allowFullScreen
                      width="560"
                      height="315"
                    />
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Vision</h4>
                    </div>
                    <p>
                      To emerge as a premier center of excellence in education,
                      research, and innovation in the frontier areas of Internet
                      of Things, Cybersecurity, and Blockchain Technology,
                      empowering students and researchers to develop
                      sustainable, secure, and intelligent solutions for
                      addressing real-world societal challenges.
                    </p>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Mission</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon justify">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To nurture globally competent professionals with
                          strong ethical values, technical expertise, and
                          interdisciplinary knowledge in IoT, Cybersecurity and
                          Blockchain domains.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To foster a culture of research, innovation, and
                          continuous learning through collaboration with
                          industries, academic institutions, and research
                          organizations.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To contribute actively to nation-building by
                          developing cutting-edge, secure, and scalable
                          solutions that address societal issues.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To become a preferred destination for aspiring
                          students and researchers seeking to explore and master
                          the future of secure, intelligent, and connected
                          world.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="section-title with-desc text-left clearfix">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        Program Educational Objectives (PEO's)
                      </h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will proficiently apply their field of study
                          to develop innovative solutions for complex, secure,
                          and interconnected digital systems.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will gain a strong foundation in engineering
                          and domain knowledge to pursue higher studies at
                          leading national and international institutions.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will engage in R&D to develop innovative,
                          secure, and scalable solutions for real-world
                          scenarios.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Graduates will develop an entrepreneurial mindset to
                          create innovative and secure IoT, Cybersecurity, and
                          Blockchain-based ventures.
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-service-single-content-area paddingtop-2">
                    <div className="section-title with-desc text-left clearfix">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">Program Outcomes</h4>
                      </div>
                    </div>
                    <div className="ttm-service-description">
                      <ul className="ttm-list ttm-list-style-icon">
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Engineering Knowledge : Apply knowledge of
                            mathematics, science, and engineering fundamentals
                            to solve complex engineering problems
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Problem Analysis : Identify, formulate, and analyze
                            complex engineering problems using research-based
                            knowledge and methodologies.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Design/Development of Solutions : Design solutions
                            for complex engineering problems that meet specified
                            needs with appropriate consideration for public
                            health and safety, cultural, societal, and
                            environmental factors.{" "}
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Conduct Investigations : Use research-based
                            knowledge and methods to conduct experiments,
                            analyze data, and synthesize information to provide
                            valid conclusions.{" "}
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Modern Tool Usage : Create, select, and apply
                            appropriate techniques, resources, and modern
                            engineering tools to complex engineering activities,
                            understanding their limitations.{" "}
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Engineer and Society : Apply reasoning informed by
                            contextual knowledge to assess societal, health,
                            safety, legal, and cultural issues relevant to
                            professional engineering practice.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Environment and Sustainability : Understand the
                            impact of professional engineering solutions in
                            societal and environmental contexts and demonstrate
                            knowledge of sustainable development.{" "}
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Ethics : Apply ethical principles and commit to
                            professional ethics and responsibilities in
                            engineering practice.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Individual and Team Work : Function effectively as
                            an individual and as a member or leader in diverse
                            teams and multidisciplinary settings.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Communication : Communicate effectively on complex
                            engineering activities with the engineering
                            community and society at large
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Project Management and Finance : Demonstrate
                            knowledge and understanding of engineering and
                            management principles to manage projects in
                            multidisciplinary environments.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Lifelong Learning : Recognize the need for, and have
                            the preparation and ability to engage in independent
                            and lifelong learning in the context of
                            technological change.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Program Specific Outcomes</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To equip students with core competencies in computer
                          science and engineering, integrating IoT,
                          cybersecurity, and blockchain to build secure
                          interconnected systems for societal challenges.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To enable our students to pursue higher learning,
                          thrive in professional careers, innovate as
                          entrepreneurs, and uphold ethical and social values.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="cyber" />
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
